import { render, staticRenderFns } from "./OpeningDateChange.vue?vue&type=template&id=52e5e89e&scoped=true&"
import script from "./OpeningDateChange.vue?vue&type=script&lang=js&"
export * from "./OpeningDateChange.vue?vue&type=script&lang=js&"
import style0 from "./OpeningDateChange.vue?vue&type=style&index=0&id=52e5e89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5e89e",
  null
  
)

export default component.exports